import { useEffect, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { LoadingSpinner } from "../../components/loading"
import { api } from "../../env"

const VerifyState = {
    LOADING: 0,
    VERIFIED: 1,
    ERORR: 2
}

export default function Verify() {
    
    const navigate = useNavigate()
    const code = new URLSearchParams(useLocation().search).get('code')

    const [state, setState] = useState(VerifyState.LOADING)

    useEffect(() => {
        setTimeout(() => handleVerify(), 1000);
    }, [])

    const handleVerify = () => {
        api.post('accounts/verify', { code })
            .then(res => {
                setState(VerifyState.VERIFIED)
            })
            .catch(err => {
                setState(VerifyState.ERORR)
            })
    }

    const handleLogin = () => navigate('/')

    return(
        <div className="flex columns center gap-l showing" style={{width: 'clamp(200px, 85%, 320px)', padding: '64px 0'}}>
            <p className="section-title">Verify Account</p>
            {state == VerifyState.LOADING && <div className="dashed-card standard-padding w-100">
                <LoadingSpinner label={'Verification in progress...'}/>
            </div>}
            {state == VerifyState.ERORR && <div className="error-card standard-padding columns gap-xs showing">
                <p className="card-title error">Error Verifying Account</p>
                <button className="solid-error" onClick={handleVerify}>Retry</button>
            </div>}
            {state == VerifyState.VERIFIED && <div className="dashed-card columns gap-s standard-padding w-100 primary showing">
                <p className="card-title">Account Verified!</p>
                <span className="material-symbols-outlined scale-3xl lighter">check_circle</span>
            </div>}
            {state != VerifyState.LOADING && <button className={`showing ${state == VerifyState.ERORR ? 'outline' : 'solid'}`} onClick={handleLogin}>Back to Login</button>}
        </div>
    )
}